import React, { useState } from 'react';
import "./NewCreatorProfile.css";
import { Image } from 'primereact/image';
import { Button } from 'primereact/button';
import youtube from "../img/youtube.png";
import NewContentListItem from "@/react_app/NewLatestItems/NewContentListItem/NewContentListItem";
import NewInviteToCampaign from "@/react_app/NewCreatorProfile/NewInviteToCampaign/NewInviteToCampaign";

const GreenCircle = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="8" fill="#4BBD07"/>
    </svg>
  )
}

const FavoriteIconInactive = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H37C38.3807 0.5 39.5 1.61929 39.5 3V37C39.5 38.3807 38.3807 39.5 37 39.5H3C1.61929 39.5 0.5 38.3807 0.5 37V3Z" fill="#130A23" stroke="white"/>
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M20.2538 26.3293L20 26.1794L19.746 26.3289L13.9262 29.7527L13.9253 29.7532C13.213 30.1742 12.4053 29.5396 12.5766 28.8204L14.1191 22.3564L14.1905 22.0573L13.9557 21.8586L8.80906 17.5035L8.80888 17.5033C8.22439 17.0092 8.51753 16.0496 9.32415 15.987L9.32415 15.987L9.32673 15.9868L16.1002 15.4252L16.3981 15.4005L16.5174 15.1264L19.1679 9.0319L19.1687 9.02993C19.4721 8.32401 20.5269 8.32401 20.8303 9.02993L20.831 9.03152L23.4815 15.1397L23.6006 15.4142L23.8989 15.4389L30.6723 16.0005L30.6749 16.0007C31.4815 16.0633 31.7746 17.0229 31.1901 17.517L31.19 17.5172L26.0433 21.8723L25.8085 22.071L25.8799 22.3701L27.4225 28.8341C27.5937 29.5533 26.786 30.1879 26.0738 29.7669L26.0736 29.7669L20.2538 26.3293Z" fill="#130A23" stroke="white"/>
    </svg>
  )
}

const SecretTip = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="none">
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M40 0V7.48746H37.5V2.49582H2.5V24.9582H20V27.454H0V0H40ZM30 7.48746C31.3802 7.48746 32.6758 7.74745 33.8867 8.26741C35.0977 8.78737 36.1589 9.49582 37.0703 10.3928C37.9818 11.2897 38.6979 12.3491 39.2188 13.571C39.7396 14.7929 40 16.0928 40 17.4708C40 18.8487 39.7526 20.1161 39.2578 21.273C38.763 22.4299 38.0404 23.5088 37.0898 24.5097L36.4648 25.1727C36.3086 25.3417 36.1458 25.5302 35.9766 25.7382C35.8073 25.9461 35.6576 26.1801 35.5273 26.4401C35.3971 26.7001 35.2865 26.9471 35.1953 27.1811C35.1042 27.415 35.0586 27.662 35.0586 27.922V31.1978C35.0586 31.7307 34.9609 32.2247 34.7656 32.6797C34.5703 33.1346 34.2969 33.5376 33.9453 33.8886C33.5938 34.2396 33.1901 34.506 32.7344 34.688C32.2786 34.87 31.7839 34.974 31.25 35H28.75C28.2161 35 27.7214 34.9025 27.2656 34.7075C26.8099 34.5125 26.4062 34.2396 26.0547 33.8886C25.7031 33.5376 25.4362 33.1411 25.2539 32.6992C25.0716 32.2572 24.9674 31.7567 24.9414 31.1978V27.922C24.9284 27.597 24.8568 27.2786 24.7266 26.9666C24.5964 26.6546 24.4336 26.3556 24.2383 26.0696C24.043 25.7837 23.8281 25.5107 23.5938 25.2507C23.3594 24.9907 23.1315 24.7437 22.9102 24.5097C21.9727 23.5218 21.2565 22.4494 20.7617 21.2925C20.2669 20.1356 20.013 18.8617 20 17.4708C20 16.0928 20.2604 14.7994 20.7812 13.5905C21.3021 12.3816 22.0117 11.3222 22.9102 10.4123C23.8086 9.50232 24.8698 8.78737 26.0938 8.26741C27.3177 7.74745 28.6198 7.48746 30 7.48746ZM32.4414 30.0084H27.5586V31.1978C27.5586 31.5227 27.6758 31.8022 27.9102 32.0362C28.1445 32.2702 28.4245 32.3872 28.75 32.3872H31.25C31.5755 32.3872 31.8555 32.2702 32.0898 32.0362C32.3242 31.8022 32.4414 31.5227 32.4414 31.1978V30.0084ZM32.6172 27.3955C32.7474 26.6546 32.9557 26.0176 33.2422 25.4847C33.5286 24.9517 33.8542 24.4578 34.2188 24.0028C34.5833 23.5478 34.9544 23.1188 35.332 22.7159C35.7096 22.3129 36.0612 21.8644 36.3867 21.3705C36.7122 20.8765 36.9792 20.324 37.1875 19.7131C37.3958 19.1021 37.5 18.3547 37.5 17.4708C37.5 16.4308 37.3047 15.4559 36.9141 14.546C36.5234 13.636 35.9896 12.8431 35.3125 12.1671C34.6354 11.4912 33.8411 10.9582 32.9297 10.5682C32.0182 10.1783 31.0417 9.98329 30 9.98329C28.9583 9.98329 27.9818 10.1783 27.0703 10.5682C26.1589 10.9582 25.3646 11.4912 24.6875 12.1671C24.0104 12.8431 23.4766 13.636 23.0859 14.546C22.6953 15.4559 22.5 16.4308 22.5 17.4708C22.5 18.4587 22.6888 19.4141 23.0664 20.337C23.444 21.26 23.9844 22.0919 24.6875 22.8329C25.0391 23.1838 25.3581 23.5218 25.6445 23.8468C25.931 24.1718 26.1914 24.5162 26.4258 24.8802C26.6602 25.2442 26.8555 25.6212 27.0117 26.0111C27.168 26.4011 27.2917 26.8626 27.3828 27.3955H32.6172Z" fill="#A8A8A8"/>
    </svg>
  )
}

const FavoriteIconActive = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H37C38.3807 0.5 39.5 1.61929 39.5 3V37C39.5 38.3807 38.3807 39.5 37 39.5H3C1.61929 39.5 0.5 38.3807 0.5 37V3Z" fill="#130A23" stroke="white"/>
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M20.2538 26.3293L20 26.1794L19.746 26.3289L13.9262 29.7527L13.9253 29.7532C13.213 30.1742 12.4053 29.5396 12.5766 28.8204L14.1191 22.3564L14.1905 22.0573L13.9557 21.8586L8.80906 17.5035L8.80888 17.5033C8.22439 17.0092 8.51753 16.0496 9.32415 15.987L9.32415 15.987L9.32673 15.9868L16.1002 15.4252L16.3981 15.4005L16.5174 15.1264L19.1679 9.0319L19.1687 9.02993C19.4721 8.32401 20.5269 8.32401 20.8303 9.02993L20.831 9.03152L23.4815 15.1397L23.6006 15.4142L23.8989 15.4389L30.6723 16.0005L30.6749 16.0007C31.4815 16.0633 31.7746 17.0229 31.1901 17.517L31.19 17.5172L26.0433 21.8723L25.8085 22.071L25.8799 22.3701L27.4225 28.8341C27.5937 29.5533 26.786 30.1879 26.0738 29.7669L26.0736 29.7669L20.2538 26.3293Z" fill="#E73D38" stroke="white"/>
    </svg>
  )
}

export default function(props) {
  const [inviteDialog, setInviteDialog] = useState(false);

  return (
    <div className={'creator-profile'}>
      <div className={'firstLayer'}>
        <div className={'darkSquare'}>
          <Image className={'userPhoto'} alt={'user photo'} src={props.creator?.profile.photo}/>
          <div className={'layer'}>
            <GreenCircle/>
            <p className={'userName'}>{props.creator?.name}</p>
          </div>
          <p className={'userType'}>Influencer</p>
          {!props.isCreator && <Button className={'inviteButton'} onClick={() => setInviteDialog(true)}>Invite to campaign</Button>}
          {!props.isCreator &&
            <div className={'favorite'} onClick={() => props.addToFavorites(props.creator?.id)}>
              {props.favorites?.allUserFavorites.find((item) => item.influences?.id === props.creator?.id) ?
                <FavoriteIconActive/> : <FavoriteIconInactive/>
              }
            </div>
          }
        </div>
        <div className={'channels'}>
          <p className={'channelsTitle'}>Channels</p>
          <div className={'channelGroup'}>
            <div className={'channelItem'}>
              <Image src={youtube} alt={'youtube logo'} width={'23px'} height={'23px'}/>
              <span className={'channelLabel'}>Youtube</span>
            </div>
          </div>
          <div>
            {props.channelsYT?.filter(channel => channel !== null).map((item, index) =>
              <div key={index} className={'channelRow'}>
                <div className={'channelSubGroupFirst'}>
                  <Image src={item?.snippet?.thumbnails?.default?.url} alt={'profile photo'} className={'channelPhoto'}/>
                  <p className={'channelInfoTextTitle'}>{item?.snippet?.title}</p>
                </div>
                <div className={'channelInfo'}>
                  <div className={'channelSubGroupSecond'}>
                    <p className={'channelInfoLabel'}>Subscribers</p>
                    <p className={'channelInfoText'}>{item?.statistics?.subscriberCount}</p>
                  </div>
                  <div className={'channelSubGroupSecond'}>
                    <p className={'channelInfoLabel'}>Total Views</p>
                    <p className={'channelInfoText'}>{item?.statistics?.viewCount}</p>
                  </div>
                  <div className={'channelSubGroupSecond'}>
                    <p className={'channelInfoLabel'}>Total videos</p>
                    <p className={'channelInfoText'}>{item?.statistics?.videoCount}</p>
                  </div>
                </div>
              </div>)}
          </div>
          {props.isCreator && <Button className={'addChannelButton'} onClick={() => props.openConnectPopup()} icon="pi pi-plus">add channel</Button>}
        </div>
      </div>
      <div className={'secondLayer'}>
        <p className={'aboutLabel'}>About</p>
        <div className={'secondLayerContent'}>
          <div className={'aboutContent'}>
            {props.creator?.profile?.description || props.creator?.agencyData?.description}
          </div>
          {!props.isCreator &&
            <div className={'secretTip'}>
              <SecretTip/>
              <div>
                <p className={'secretTipLabel'}>Secret Tip</p>
                <p className={'secretTipText'}>
                  You can invite any influencer to take part in your campaign!<br/>
                  <a className={'readGuide'} target={'_blank'} href={'https://gameinfluencer.com/blog/'}>Read our guide</a> on how to make your campaign more attractive for content creators.
                </p>
              </div>
            </div>
          }
        </div>
      </div>
      <div className={'contentItemsWrapper'}>
        <p className={'contentLabel'}>Content</p>
        <div className={'contentItems'}>
          {props.creator?.contentItems.map((item, index) =>
            <div key={index} className={'contentItemWrapper'}>
              <NewContentListItem item={item} handleRouting={() => props.handleContentRouting(item.id)}/>
            </div>)}
        </div>
      </div>
      {!props.isCreator &&
        <NewInviteToCampaign visible={inviteDialog} onHide={() => setInviteDialog(false)} creator={props.creator}
                             campaignOptions={props.campaignOptions}/>
      }
    </div>
  )
}
